if (!customElements.get('product-form-custom')) {
    customElements.define('product-form-custom', class ProductFormCustom extends HTMLElement {
      constructor() {
        super();
  
        this.forms = this.querySelectorAll('form');
        this.forms.forEach(form=>form.querySelector('[name=id]').disabled = false)
        this.forms.forEach(form=>form.addEventListener('submit', this.onSubmitHandler.bind(this)))
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.quantityInput = this.querySelector('quantity-input input[name="quantity"]')
        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        if(this.quantityInput){
          this.quantityInput.addEventListener('change', this.onQuantityChange.bind(this))
        }
      }

      onQuantityChange(evt){
        this.querySelector('.add-to-cart-btn').removeAttribute("data-price-mutation-watcher")
        console.log("change", evt.target.value)
        const newPrice = this.quantityInput.dataset.prodPrice * parseInt(evt.target.value)
        console.log("newPrice", this.querySelector('.add-to-cart-btn .price'))
        this.querySelector('.add-to-cart-btn .price').innerHTML = (newPrice / 100).toFixed(2).replace('.', ',') + "€"
      }
  
      onSubmitHandler(evt) {
        const form = evt.target
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
        
        //Check if max quantity is met and return
        fetch(`${routes.cart_url}?view=max_items`)
        .then(res=>res.json())
        .then(res=>{
          console.log(res)
          const cartMaxItems = parseInt(this.cart.querySelector('.cart-drawer').dataset.maxItems)
          const quantity = parseInt(res.total_items)
          if(quantity>=cartMaxItems){
            // alert("Error")
            this.querySelector('.product-form__max-quantity-error').classList.remove("hidden")
            return
          }

          this.handleErrorMessage();
    
          this.submitButton.setAttribute('aria-disabled', true);
          this.submitButton.classList.add('loading');
    
          const config = fetchConfig('javascript');
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          delete config.headers['Content-Type'];
    
          // const formData = new FormData(form);
    
          // if (this.cart) {
          //   formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
          //   formData.append('sections_url', window.location.pathname);
          //   this.cart.setActiveElement(document.activeElement);
          // }
          
          const formData = {
            items: [
              {
              id: parseInt(form.querySelector('input[name="id"]').value),
              quantity: this.querySelector('input[name="quantity"]') ? parseInt(this.querySelector('input[name="quantity"]').value) : 1
            }],
            sections: "cart-drawer,cart-icon-bubble"
          }

          if(form.querySelector('input[name="selling_plan"]')){
            formData.items[0].selling_plan = parseInt(form.querySelector('input[name="selling_plan"]').value)
          }

          if(form.querySelector('input[name="gift"]')){
            formData.items.push({
              id: parseInt(form.querySelector('input[name="gift"]').value),
              quantity: 1,
              parent_id: parseInt(form.querySelector('input[name="id"]').value),
              properties: JSON.parse(form.querySelector('input[name="gift"]').dataset.properties)
            })
          }

          config.body = formData;
          
          fetch(`${routes.cart_add_url}.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
          })
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {
                this.handleErrorMessage(response.description);
    
                const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
                if (!soldOutMessage) return;
                this.submitButton.setAttribute('aria-disabled', true);
                this.submitButton.querySelector('span').classList.add('hidden');
                soldOutMessage.classList.remove('hidden');
                this.error = true;
                return;
              } else if (!this.cart) {
                window.location = window.routes.cart_url;
                return;
              }
    
              this.error = false;
              const quickAddModal = this.closest('quick-add-modal');
              if (quickAddModal) {
                document.body.addEventListener('modalClosed', () => {
                  setTimeout(() => { this.cart.renderContents(response) });
                }, { once: true });
                quickAddModal.hide(true);
              } else {
                console.log(response)
                const template = window.template;
                const isEs = (Shopify.country == "ES")
                if(template === 'mujer-test' && isEs){
                  window.location = "/checkout"
                }else{
                  this.cart.renderContents(response)
                }
                //this.cart.renderContents(response);
              }
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
              this.submitButton.classList.remove('loading');
              if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
              if (!this.error) this.submitButton.removeAttribute('aria-disabled');
              const items = []
              this.querySelectorAll(".product-gift").forEach(item=>{
                console.log(JSON.parse(item.dataset.properties))
                items.push({
                  id: item.value,
                  quantity: 1,
                  properties: JSON.parse(item.dataset.properties)
                })
              })
              
              if(items.length && false){
                fetch(`${routes.cart_add_url}`, {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: JSON.stringify({
                    items: items
                  })
                })
                .then(response => response.json())
                .then(response=>{
                  this.cart.renderContents(response);
                })
                .catch(error => console.error('Error:', error));
              }
            });
        })

      }
  
      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
  
        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
  
        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    });
  }
  